import { PureComponent } from 'react'
import { $ } from 'utils'
import glamorous from 'glamorous'
import map from 'lodash/map'
import Link from 'react-router-dom/Link'
import { withRouter } from 'react-router-dom'
import { Icon, Tooltip } from 'components'

const Container = glamorous.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 0,
  flexShrink: 0,
  justifyContent: 'center',
  alignItems: 'center',
  width: 100,
  height: '100%',
  backgroundColor: 'white',
  boxShadow: '5px 0 10px 0 rgba(216, 210, 210, 0.15)'
})

const Logo = glamorous(Link)({
  position: 'absolute',
  top: 38,
  textAlign: 'center',
  textDecoration: 'none',
})

const LogoText = glamorous.div({
  marginTop: 10,
  fontSize: 16,
  fontWeight: 600,
  letterSpacing: '2.6px',
  color: 'var(--grey)'
}, ({ fontSize }) => ({
  fontSize
}))

const IconStyles = {
  width: 100,
  height: 67,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
}

const IconWithProps = ({ selected }) => selected && {
  '&:before': {
    content: ' ',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '4px',
    backgroundColor: 'var(--violet)',
  }
}

const ItemLinkContainer = glamorous(Link)(IconStyles, IconWithProps, 'menuItem')
const ItemDisableContainer = glamorous.div(IconStyles, IconWithProps, 'menuItem')

const MenuItem = (_, type, selectedPage) => {
  const selected = selectedPage.indexOf(`/${type}`) === 0
  const isDisabled = type === 'dashboard'
  if (isDisabled) {
    return (
      $(ItemDisableContainer, { key: type, selected },
        $(Tooltip, { tip: type },
          $(Icon, { type, isActive: selected, isDisabled, colorActive: 'var(--violet)' })
        ),
      )
    )
  } else {
    return (
      $(ItemLinkContainer, { to: `/${type}`, key: type, selected },
        $(Tooltip, { tip: type },
          $(Icon, { type, isActive: selected, colorActive: 'var(--violet)' })
        ),
      )
    )
  }
}

export class LeftPanel extends PureComponent {

  render = () => {

    const selectedPage = this.props.location.pathname
    const pages = this.props.pages
    return (
      $(Container,
        $(Logo, { to: '/' },
          $(Icon, { type: 'luna', size: 46, color: 'var(--violet)', isHoverable: false }),
          $(LogoText, 'LUNA'),
          $(LogoText, { fontSize: 11 }, 'PLATFORM'),
        ),
        map(pages, (_, type) => MenuItem(_, type, selectedPage))
      )
    )
  }
}

export default withRouter(LeftPanel)


// WEBPACK FOOTER //
// ./src/pages/MainLayout/LeftPanel.js